import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledTitle = styled.h1 `
  font-weight: ${({ $fontWeight }) => $fontWeight || 'normal'};
  margin-top: ${({ $marginTop, $marginY }) => $marginTop || $marginY || '0'};
  margin-right: ${({ $marginRight, $marginX }) => $marginRight || $marginX || '0'};
  margin-bottom: ${({ $marginBottom, $marginY }) => $marginBottom || $marginY || '0'};
  margin-left: ${({ $marginLeft, $marginX }) => $marginLeft || $marginX || '0'};
`;
const Title = ({ text, level = 1, className, fontWeight, marginTop, marginRight, marginBottom, marginLeft, marginX, marginY }) => {
    const Tag = `h${level}`;
    return (_jsx(StyledTitle, { as: Tag, className: className, "$fontWeight": fontWeight, "$marginTop": marginTop, "$marginRight": marginRight, "$marginBottom": marginBottom, "$marginLeft": marginLeft, "$marginX": marginX, "$marginY": marginY, children: text }));
};
export default Title;
